module.exports = __webpack_public_path__ + "img/3_97.90cb914f.png";